<template>
  <div class="">
    <landing />
    <About id="about" />
    <Program id="program" />
    <!-- <Sec3 /> -->
    <Different id="different" />
    <Outline id="outline" />
    <!-- <Saying /> -->
    <Certificate />
    <Video />
    <Testimonial />
    <Faq id="faq" />

    <Contact />
  </div>
</template>

<script>
import Faq from '../../../components/faq/bongoFaq.vue'
import Landing from '../../../components/BongoIsa/LandingBongo.vue'
import Contact from '../../../components/BongoIsa/Contactds.vue'
// import Sec3 from '../components/IsaData/Section4thIm.vue'
import Certificate from '../../../components/BongoIsa/Certificate.vue'
import Different from '../../../components/BongoIsa/Different.vue'
import About from '../../../components/BongoIsa/About.vue'
import Program from '../../../components/BongoIsa/Program.vue'
import Outline from '../../../components/BongoIsa/Outline.vue'
import Video from '../../../components/BongoIsa/VideoSection.vue'
import Testimonial from '../../../components/BongoIsa/TestimonialBongo.vue'
// import Saying from '../components/BongoIsa/Saying.vue'
export default {
  components: {
    Landing,
    Contact,
    // Saying,
    // Sec3,
    Certificate,
    Different,
    About,
    Program,
    Outline,
    Faq,
    Video,
    Testimonial,
  },
  created() {
    this.Loaded()
  },
}
</script>

<style></style>
